import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const types = {
  IS_MOBILE: 'IS_MOBILE',
  MENU_LIST: 'MENU_LIST'
}

export default new Vuex.Store({
  state: {
    [types.IS_MOBILE]: false,
    [types.MENU_LIST]: []
  },
  mutations: {
    [types.IS_MOBILE]: (state, res) => {
      state[types.IS_MOBILE] = res
    },
    [types.MENU_LIST]: (state, res) => {
      state[types.MENU_LIST] = res
    }
  },
  actions: {
    [types.MENU_LIST]: async ({ commit }, params) => {
    }
  },
  getters: {
    getTerminalForChrome (state) {
      return state[types.IS_MOBILE]
    },
    getMenuList (state) {
      return state[types.MENU_LIST]
    }
  },
  modules: {}
})
